import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { log } from "console";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { ApiService } from "src/app/providers/api.service";
import { Subscription } from "rxjs";

@Component({
  selector: "sm-add-existing-account",
  templateUrl: "./add-existing-account.component.html",
  styleUrls: ["./add-existing-account.component.scss"],
})
export class AddExistingAccountComponent implements OnInit,OnDestroy {
  loader: boolean = false;
  apisub: Subscription
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private activemodal: MatDialogRef<AddExistingAccountComponent>
  ) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_LINK_DOMESTIC_ENTITY_BANK_ACCOUNT){
        if(resdata.result){
          this.activemodal.close(resdata.result)
        }
      }
    })

  }
  selectedAccount: any = null;
  ngOnInit(): void {
    this.loader = true;
    console.log(this.parentdata.bankAccounts);
    this.parentdata.bankAccounts.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.loader = false;
  }

  selectAccount(item: any) {
    this.parentdata.bankAccounts.forEach((element: any) => {
      element.isSelected = 0;
    });
    item.isSelected = 1;
    this.selectedAccount = item;
  }

  onPost() {
    let obj = {
      hash_id: this.selectedAccount.hashId,
      created_by_account_hash: localStorage.getItem(
        SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
      ),
      entity_hash: this.parentdata.entityHash,
    };

    console.log(obj);
    this.ls.showLoader = true;
    this.apiservice.linkDomesticEntityBankAccount(obj)
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe
  }
}
